import React, { useState } from "react";
import { useNavigate } from 'react-router-dom'
import {toast} from 'react-hot-toast'
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
} from "@mui/material";

// eslint-disable-next-line
import { useDispatch , useSelector } from "react-redux";

const Deposit = ({ user, token }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  
  const loggeinUserPhone = useSelector((state)=>state.user.buyer.phone)
  // console.log(loggeinUserPhone)

  function convertToLocalFormat(phoneNumber) {
    // Remove the leading '+' if it exists
    phoneNumber = phoneNumber.replace('+', '');
  
    // Check if the phone number starts with the country code '254'
    if (phoneNumber.startsWith('254')) {
      // Already in local format, return as is
      return phoneNumber;
    } else {
      // Add the country code '254' to the phone number
      return '254' + phoneNumber;
    }
  }

 const phone_number = convertToLocalFormat( loggeinUserPhone );
//  console.log(phone_number)


  const [depositData, setDepositData] = useState({
    amount: 0, // Initialize amount as a decimal (0.0)
    phoneNumber: phone_number
  });

  const [message, setMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Convert the value to a float for the 'amount' field
    const floatValue = parseFloat(value);

    setDepositData({
      ...depositData,
      [name]: floatValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)


    // Define the API endpoint for deposit
    const apiUrl = "https://salama-api.onrender.com/stkpush";

    // Prepare the request headers
    const headers = {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${token}`, // Include the token in the Authorization header
    };

    // Prepare the request body
    const requestBody = JSON.stringify(depositData);
    console.log(requestBody)

    // Make the POST request to the /deposits endpoint
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: requestBody,
      });

      if (!response.ok) {
        // Handle error responses here
        const errorData = await response.json();
        throw new Error(errorData.message || "Network response was not ok");
      }

      // Request was successful
      const data = await response.json();
      setMessage("Deposit successful!");
      toast.success(`deposit initiated check your phone and enter you pin`);
      setLoading(false)
      console.log("Deposit Data:", data);
      navigate('/user')
    } catch (error) {
      // Handle any errors that occurred during the fetch
      console.error("Error:", error);
      setMessage("An error occurred while processing your request.");
      setLoading(false)
    }
  };

  return (

      <div style={{ flex: "1", padding: "2rem" }}>
        <Typography variant="h4" align="left" gutterBottom>
          Make a Deposit
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                name="amount"
                type="number"
                variant="outlined"
                value={depositData.amount}
                onChange={handleInputChange}
                required
              />
            </Grid>
          </Grid>
          <Box mt={3}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={ loading }
            >
              {loading ? "loading ..." : "Deposit"}
            </Button>
          </Box>
        </form>
        {message && <p>{message}</p>}
      </div>
  );
};

export default Deposit;